import {
  ValidationMessage,
  ValidationMessageFunction,
} from "@/models/validation-message";
import { z } from "zod";

export const getUpdateUserSchema = () =>
  z.object({
    username: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .optional(),
    name: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .optional(),
    phone: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .max(30, ValidationMessageFunction.MAX(30))
      .optional(),
    email: z
      .string()
      .nonempty({ message: ValidationMessage.NON_EMPTY })
      .email({ message: ValidationMessage.EMAIL })
      .optional(),
  });
